import { render } from "./ReferenceConclusionBlock.vue?vue&type=template&id=31ea8784&scoped=true"
import script from "./ReferenceConclusionBlock.vue?vue&type=script&lang=js"
export * from "./ReferenceConclusionBlock.vue?vue&type=script&lang=js"

import "./ReferenceConclusionBlock.vue?vue&type=style&index=0&id=31ea8784&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ea8784"]])

export default __exports__